import React from 'react'
import styles from '@/styles/shared/Container.module.css'
import Background from './Background'

const Container = ({ children, background }) => {
  return (
    <div className={`${styles.margin}`}>
      <Background background={background} />
      <div className={`${styles.container}`}>
        {children}
      </div>
    </div>
  )
}

export default Container
